import { z } from 'zod';

/** Corps d'erreur de toute l'API, CDC §3.1. */
export const ErrorBody = z.object({
  error: z.object({
    code: z.string().regex(/^[A-Z][A-Z0-9_]*$/),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ErrorBody = z.infer<typeof ErrorBody>;

/** Codes d'erreur communs (les modules en ajoutent d'autres, toujours en SNAKE_CASE). */
export const ErrorCodes = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  // Connexion
  NOT_INVITED: 'NOT_INVITED',
  USER_DISABLED: 'USER_DISABLED',
  DOMAIN_NOT_ALLOWED: 'DOMAIN_NOT_ALLOWED',
  // Membres
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  CANNOT_MODIFY_SELF: 'CANNOT_MODIFY_SELF',
  // Connexions
  PROVIDER_ERROR: 'PROVIDER_ERROR',
  JOBS_DISABLED: 'JOBS_DISABLED',
  // Plans (CDC §3.4)
  PLAN_ALREADY_EXECUTED: 'PLAN_ALREADY_EXECUTED',
  PLAN_CANCELLED: 'PLAN_CANCELLED',
  PLAN_EXPIRED: 'PLAN_EXPIRED',
  PLAN_NOT_OWNED: 'PLAN_NOT_OWNED',
  PLAN_KIND_NOT_AVAILABLE: 'PLAN_KIND_NOT_AVAILABLE',
  PLAN_KIND_NOT_IMPLEMENTED: 'PLAN_KIND_NOT_IMPLEMENTED',
  NOTHING_TO_EXECUTE: 'NOTHING_TO_EXECUTE',
  UNKNOWN_STEP: 'UNKNOWN_STEP',
  INVALID_CHOICE: 'INVALID_CHOICE',
  INVALID_EDIT: 'INVALID_EDIT',
  INVALID_STEP_INPUT: 'INVALID_STEP_INPUT',
  // Données (lot B)
  GOOGLE_NOT_CONNECTED: 'GOOGLE_NOT_CONNECTED',
  NOT_AVAILABLE_YET: 'NOT_AVAILABLE_YET',
  INVALID_FILE: 'INVALID_FILE',
  INVALID_SPREADSHEET_URL: 'INVALID_SPREADSHEET_URL',
  CLIENT_ALREADY_LINKED: 'CLIENT_ALREADY_LINKED',
  ALREADY_LINKED: 'ALREADY_LINKED',
  SHEET_NOT_FOUND: 'SHEET_NOT_FOUND',
  IMPORTED_EXPENSE: 'IMPORTED_EXPENSE',
  // À faire (lot C)
  ACTION_NOT_FOUND: 'ACTION_NOT_FOUND',
  ACTION_CLOSED: 'ACTION_CLOSED',
  ACTION_NOT_SUPPORTED: 'ACTION_NOT_SUPPORTED',
  UNKNOWN_ASSIGNEE: 'UNKNOWN_ASSIGNEE',
  UNKNOWN_CLIENT: 'UNKNOWN_CLIENT',
  UNKNOWN_PROJECT: 'UNKNOWN_PROJECT',
  NO_CLIENT_EMAIL: 'NO_CLIENT_EMAIL',
  NO_FREE_SLOT: 'NO_FREE_SLOT',
  AI_CAP_REACHED: 'AI_CAP_REACHED',
  // Retours (pièce jointe)
  ATTACHMENT_TOO_LARGE: 'ATTACHMENT_TOO_LARGE',
  ATTACHMENT_TYPE_NOT_ALLOWED: 'ATTACHMENT_TYPE_NOT_ALLOWED',
  FEEDBACK_NOT_OWNED: 'FEEDBACK_NOT_OWNED',
} as const;
export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
